import { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";

const navLinks = [
  { to: "/", label: "首页" },
  { to: "/biaoqian", label: "分类榜单" },
  { to: "/about", label: "关于我们" },
  { to: "/faq", label: "常见问题" },
];

export default function Navbar({ overlay = false }: { overlay?: boolean }) {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 30);
    onScroll();
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  useEffect(() => {
    setOpen(false);
  }, [location.pathname]);

  const solid = !overlay || scrolled || open;

  return (
    <header
      className={`fixed inset-x-0 top-0 z-50 transition-all duration-300 ${
        solid ? "bg-background-50/90 backdrop-blur-md border-b border-background-200" : "bg-transparent"
      }`}
    >
      <nav className="container-x flex h-16 items-center justify-between">
        <Link to="/" className="flex items-center gap-2.5">
          <span className="flex h-9 w-9 items-center justify-center rounded-full bg-primary-500 text-background-50">
            <i className="ri-bowl-fill text-lg"></i>
          </span>
          <span
            className={`font-heading text-xl font-bold tracking-wide ${
              solid ? "text-foreground-950" : "text-background-50"
            }`}
          >
            小水看番
          </span>
        </Link>

        <div className="hidden items-center gap-1 md:flex">
          {navLinks.map((item) => (
            <Link
              key={item.to}
              to={item.to}
              className={`rounded-full px-4 py-2 text-sm font-medium transition-colors ${
                location.pathname === item.to
                  ? "bg-primary-100 text-primary-700"
                  : solid
                  ? "text-foreground-700 hover:bg-background-200 hover:text-foreground-950"
                  : "text-background-50/90 hover:bg-background-50/20 hover:text-background-50"
              }`}
            >
              {item.label}
            </Link>
          ))}
        </div>

        <div className="hidden items-center gap-3 md:flex">
          <Link
            to="/biaoqian"
            className="flex h-10 w-10 items-center justify-center rounded-full bg-background-100 text-foreground-700 transition-colors hover:bg-background-200"
            aria-label="搜索番剧"
          >
            <i className="ri-search-line text-lg"></i>
          </Link>
          <Link
            to="/biaoqian"
            className="btn-pill bg-primary-500 text-background-50 hover:bg-primary-600"
          >
            开始看番 <i className="ri-arrow-right-line"></i>
          </Link>
        </div>

        <button
          type="button"
          onClick={() => setOpen((v) => !v)}
          className={`flex h-10 w-10 items-center justify-center rounded-full md:hidden ${
            solid ? "bg-background-100 text-foreground-900" : "bg-background-50/20 text-background-50"
          }`}
          aria-label="展开菜单"
        >
          <i className={`${open ? "ri-close-line" : "ri-menu-line"} text-xl`}></i>
        </button>
      </nav>

      {open && (
        <div className="border-t border-background-200 bg-background-50 px-4 py-3 md:hidden">
          <div className="flex flex-col gap-1">
            {navLinks.map((item) => (
              <Link
                key={item.to}
                to={item.to}
                className={`rounded-lg px-4 py-2.5 text-sm font-medium ${
                  location.pathname === item.to
                    ? "bg-primary-100 text-primary-700"
                    : "text-foreground-700 hover:bg-background-100"
                }`}
              >
                {item.label}
              </Link>
            ))}
          </div>
        </div>
      )}
    </header>
  );
}